import poolView from '../assets/images/Gallery/Pool-overview.jpg';
import villaFrontView from '../assets/images/Gallery/villa-front-view-2.jpg';
import sittingArea from '../assets/images/Gallery/sitting-area.jpg';
import droneView from '../assets/images/Gallery/drone-view-3.jpg';
import centerVilla from '../assets/images/Gallery/center-villa.jpg';
import entrance from '../assets/images/Gallery/entrance.jpg';
import sittingLounge from '../assets/images/Gallery/villa-sitting-lounge.jpg';
import scenery3 from '../assets/images/Gallery/scenery3.jpg';
import scenicView from '../assets/images/Gallery/scenery.jpg';
import treeView from '../assets/images/Gallery/Tree.jpg';
import servingDrinks from '../assets/images/Gallery/serving-drinks.jpg';
import villaDroneView from '../assets/images/Gallery/villa-drone-view.jpg';

const galleryImages = [
  { src: poolView, alt: 'Pool View' },
  { src: villaFrontView, alt: 'Villa Front View' },
  { src: sittingArea, alt: 'Sitting Area' },
  { src: droneView, alt: 'Drone View' },
  { src: centerVilla, alt: 'Center of Villa' },
  { src: entrance, alt: 'Villa Entrance' },
  { src: sittingLounge, alt: 'Sitting Lounge' },
  { src: scenery3, alt: 'Beautiful Scenery' },
  { src: scenicView, alt: 'Scenic View' },
  { src: treeView, alt: 'Tree by the Villa' },
  { src: servingDrinks, alt: 'Serving Drinks' },
  { src: villaDroneView, alt: 'Villa Drone View' },
];

export default galleryImages;
